import { useContext } from "react";
import { DisplaySettingsContext } from "../state/contexts";

function useDisplaySettings() {
  return useContext(DisplaySettingsContext);
}

export default useDisplaySettings;
